import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import { FC, ReactElement } from 'react'
import styled from 'styled-components'
import { Grid } from '../Grid'
import ticinoData from '../../data/ticino.json'
import munichData from '../../data/munich.json'
import viennaData from '../../data/vienna.json'
import veniceData from '../../data/venice.json'
import parisData from '../../data/paris.json'
import { GlobalVariables } from 'Globals/GlobalVariables'

const defaultProperties: { [key: string]: string } = {
  module: 'paris', // munich / vienna / venice / paris
  title: 'Nach Paris', // munich / vienna / venice / paris
}

const MainComponent: FC<MicroFrontendProps> = ({
  tenant,
  colorMode,
  properties = defaultProperties,
}): ReactElement => {
  const modules: { [key: string]: ReactElement } = {
    ticino: (
      <Grid
        module={
          properties.module ? properties.module : defaultProperties.module
        }
        title={properties.title ? properties.title : defaultProperties.title}
        destination='Tessin'
        data={ticinoData}
        tenant={tenant}
        colorMode={colorMode}
      />
    ),
    munich: (
      <Grid
        module={
          properties.module ? properties.module : defaultProperties.module
        }
        title={properties.title ? properties.title : defaultProperties.title}
        destination='München'
        data={munichData}
        tenant={tenant}
        colorMode={colorMode}
      />
    ),
    vienna: (
      <Grid
        module={
          properties.module ? properties.module : defaultProperties.module
        }
        title={properties.title ? properties.title : defaultProperties.title}
        destination='Wien'
        data={viennaData}
        tenant={tenant}
        colorMode={colorMode}
      />
    ),
    venice: (
      <Grid
        module={
          properties.module ? properties.module : defaultProperties.module
        }
        title={properties.title ? properties.title : defaultProperties.title}
        destination='Venedig'
        data={veniceData}
        tenant={tenant}
        colorMode={colorMode}
      />
    ),
    paris: (
      <Grid
        module={
          properties.module ? properties.module : defaultProperties.module
        }
        title={properties.title ? properties.title : defaultProperties.title}
        destination='Paris'
        data={parisData}
        tenant={tenant}
        colorMode={colorMode}
      />
    ),
  }

  return (
    <AppContainer $colorMode={colorMode}>
      {properties.module && modules[properties.module]
        ? modules[properties.module]
        : modules[defaultProperties.module]}
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)`${GlobalVariables}
  font-family: var(--font-sans-serif);
  font-size: 1.8rem;
  line-height: 3rem;
`
export default MainComponent
